import React, { Component } from 'react';
import { Link } from "react-router-dom";

class NavBar extends Component {
	
	renderMickey() {
		return (<div className="blank-btn-left" />);
		//mickey ears back button. May have copyright issue
		// return (
		// 	<div className="mickey">
		// 		<div className="ear left"></div>
		// 		<div className="ear right"></div>
		// 		<div className="head"></div>
		// 	</div>
		// );
	}

	renderSave() {
		var url = "/save";
		
		return (
			<Link to={url} className="save-btn" >
			</Link>
		);
	}

	renderMickeyBack() {
		var url = "";
		if(this.props.nav_stack!==undefined && this.props.nav_stack.length>1) {
			for(var i=0;i<this.props.nav_stack.length-1;i++) {
				url += "/"+this.props.nav_stack[i];
			}
		}
		if(url.length) url += "/disneyland.html";
		return (
			<Link to={url} className="bk-btn" id="backButton" onClick={this.props.onBack} title="Back">
				<div className="bk-btn-triangle"></div><div className="bk-btn-bar"></div>
			</Link>
		);
		//mickey ears back button. May have copyright issue
		// return (
		// 	<Link to={url} className="mickey" onClick={this.props.onBack}>
		// 		<div className="ear left"></div>
		// 		<div className="ear right"></div>
		// 		<div className="head"></div>
		// 		<div className="bk-btn-triangle"></div><div className="bk-btn-bar"></div>
		// 	</Link>
		// );
	}

	render() {
 		var back = null;
 		var save = null;

		if(this.props.nav_stack.length===0) back = this.renderMickey();//(<img src={ears} alt="" />);
		else back = this.renderMickeyBack();//(<a href="#" onClick={this.props.onBack} className="bk-btn"><div className="bk-btn-triangle"></div><div className="bk-btn-bar"></div></a>);

		if(this.props.nav_stack.length===0) save = this.renderSave();
		else save = (<div className="blank-btn-right" />);

		return (
			<div className="navbar">
				{back} <h1>{this.props.title}</h1> {save}
			</div>
		);
	}


}



export default NavBar;



// WEBPACK FOOTER //
// ./src/NavBar.js